// Road weather/traffic stations and road notices from Vegagerðin's umferdin.is,
// via our own /api/roads function (see functions/roads.js).
const ROADS_URL = "/api/roads";

export const ROADS_SOURCE_URL = "https://umferdin.is/";

export const fetchRoads = async () => {
  const response = await fetch(ROADS_URL);
  const body = await response.json().catch(() => null);
  if (!response.ok || !Array.isArray(body?.stations)) {
    throw new Error(body?.error ?? `Road data responded ${response.status}`);
  }
  return body; // { stations, notices, fetchedAt }
};

const num = (n, digits = 1) =>
  n == null
    ? null
    : n.toLocaleString("is-IS", { maximumFractionDigits: digits });

// "8°C" (air) and the road-surface temperature; null when not reported
export const formatTemp = (t) => (t == null ? null : `${num(t)}°C`);

// "7 m/s, gust 12 · SSA" from speed, gust and direction
export const formatWind = ({ wind, gust, windDir }) => {
  if (wind == null) return null;
  const gustPart = gust != null ? `, gust ${num(gust)}` : "";
  const dirPart = windDir ? ` · ${windDir}` : "";
  return `${num(wind)} m/s${gustPart}${dirPart}`;
};

// Whole-vehicle counts: "1.234 today" and the current flow if present
export const formatTraffic = ({ traffic, trafficToday }) =>
  [
    traffic != null && `${num(traffic, 0)} now`,
    trafficToday != null && `${num(trafficToday, 0)} today`,
  ]
    .filter(Boolean)
    .join(" · ") || null;

// A station reads "icy" when its road surface is at or below freezing
export const isIcy = (station) =>
  station.roadTemp != null && station.roadTemp <= 0;

// Group notices by Vegagerðin's region, in a sensible order with the capital
// first; "Frá veðurfræðingi" (from the forecaster) and warnings lead
const REGION_ORDER = [
  "Viðvörun",
  "Frá veðurfræðingi",
  "Höfuðborgarsvæðið",
  "Suðvesturland",
  "Suðurland",
  "Vesturland",
  "Vestfirðir",
  "Norðurland",
  "Norðausturland",
  "Suðausturland",
  "Hálendið",
  "Þungatakmarkanir",
];

export const groupNotices = (notices) => {
  const byRegion = new Map();
  for (const n of notices) {
    if (!byRegion.has(n.region)) byRegion.set(n.region, []);
    byRegion.get(n.region).push(n);
  }
  return [...byRegion.entries()].sort(
    (a, b) =>
      (REGION_ORDER.indexOf(a[0]) + 1 || 99) -
      (REGION_ORDER.indexOf(b[0]) + 1 || 99),
  );
};
